"use strict";

var cov_2cdkxug3hl = function () {
  var path = "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\helpers.js";
  var hash = "358c63004dd457f3bae829bd8c83abb120609bde";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "C:\\Projects-UnfoldingWord\\scripture-resources-rcl\\src\\components\\parallel-scripture\\helpers.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 37
        },
        end: {
          line: 17,
          column: 1
        }
      },
      "1": {
        start: {
          line: 4,
          column: 23
        },
        end: {
          line: 4,
          column: 34
        }
      },
      "2": {
        start: {
          line: 6,
          column: 2
        },
        end: {
          line: 15,
          column: 5
        }
      },
      "3": {
        start: {
          line: 7,
          column: 4
        },
        end: {
          line: 14,
          column: 7
        }
      },
      "4": {
        start: {
          line: 8,
          column: 22
        },
        end: {
          line: 8,
          column: 47
        }
      },
      "5": {
        start: {
          line: 10,
          column: 6
        },
        end: {
          line: 13,
          column: 9
        }
      },
      "6": {
        start: {
          line: 11,
          column: 28
        },
        end: {
          line: 11,
          column: 55
        }
      },
      "7": {
        start: {
          line: 12,
          column: 8
        },
        end: {
          line: 12,
          column: 38
        }
      },
      "8": {
        start: {
          line: 16,
          column: 2
        },
        end: {
          line: 16,
          column: 27
        }
      },
      "9": {
        start: {
          line: 19,
          column: 34
        },
        end: {
          line: 23,
          column: 1
        }
      },
      "10": {
        start: {
          line: 20,
          column: 24
        },
        end: {
          line: 20,
          column: 40
        }
      },
      "11": {
        start: {
          line: 21,
          column: 18
        },
        end: {
          line: 21,
          column: 55
        }
      },
      "12": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 17
        }
      },
      "13": {
        start: {
          line: 25,
          column: 43
        },
        end: {
          line: 38,
          column: 1
        }
      },
      "14": {
        start: {
          line: 28,
          column: 2
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "15": {
        start: {
          line: 29,
          column: 4
        },
        end: {
          line: 35,
          column: 5
        }
      },
      "16": {
        start: {
          line: 30,
          column: 22
        },
        end: {
          line: 30,
          column: 71
        }
      },
      "17": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 34,
          column: 7
        }
      },
      "18": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 26
        }
      },
      "19": {
        start: {
          line: 37,
          column: 2
        },
        end: {
          line: 37,
          column: 15
        }
      },
      "20": {
        start: {
          line: 40,
          column: 45
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "21": {
        start: {
          line: 41,
          column: 21
        },
        end: {
          line: 65,
          column: 4
        }
      },
      "22": {
        start: {
          line: 42,
          column: 22
        },
        end: {
          line: 42,
          column: 59
        }
      },
      "23": {
        start: {
          line: 43,
          column: 24
        },
        end: {
          line: 43,
          column: 56
        }
      },
      "24": {
        start: {
          line: 44,
          column: 20
        },
        end: {
          line: 44,
          column: 63
        }
      },
      "25": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 51,
          column: 5
        }
      },
      "26": {
        start: {
          line: 48,
          column: 24
        },
        end: {
          line: 48,
          column: 48
        }
      },
      "27": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 83
        }
      },
      "28": {
        start: {
          line: 50,
          column: 6
        },
        end: {
          line: 50,
          column: 37
        }
      },
      "29": {
        start: {
          line: 53,
          column: 4
        },
        end: {
          line: 57,
          column: 5
        }
      },
      "30": {
        start: {
          line: 54,
          column: 25
        },
        end: {
          line: 54,
          column: 41
        }
      },
      "31": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 86
        }
      },
      "32": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 29
        }
      },
      "33": {
        start: {
          line: 59,
          column: 21
        },
        end: {
          line: 59,
          column: 36
        }
      },
      "34": {
        start: {
          line: 61,
          column: 4
        },
        end: {
          line: 63,
          column: 5
        }
      },
      "35": {
        start: {
          line: 62,
          column: 6
        },
        end: {
          line: 62,
          column: 95
        }
      },
      "36": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 64,
          column: 37
        }
      },
      "37": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 20
        }
      },
      "38": {
        start: {
          line: 69,
          column: 29
        },
        end: {
          line: 92,
          column: 1
        }
      },
      "39": {
        start: {
          line: 70,
          column: 23
        },
        end: {
          line: 70,
          column: 55
        }
      },
      "40": {
        start: {
          line: 71,
          column: 15
        },
        end: {
          line: 90,
          column: 4
        }
      },
      "41": {
        start: {
          line: 72,
          column: 14
        },
        end: {
          line: 72,
          column: 29
        }
      },
      "42": {
        start: {
          line: 74,
          column: 4
        },
        end: {
          line: 88,
          column: 7
        }
      },
      "43": {
        start: {
          line: 75,
          column: 37
        },
        end: {
          line: 75,
          column: 59
        }
      },
      "44": {
        start: {
          line: 76,
          column: 26
        },
        end: {
          line: 76,
          column: 59
        }
      },
      "45": {
        start: {
          line: 77,
          column: 22
        },
        end: {
          line: 77,
          column: 43
        }
      },
      "46": {
        start: {
          line: 79,
          column: 6
        },
        end: {
          line: 83,
          column: 7
        }
      },
      "47": {
        start: {
          line: 80,
          column: 26
        },
        end: {
          line: 80,
          column: 50
        }
      },
      "48": {
        start: {
          line: 81,
          column: 22
        },
        end: {
          line: 81,
          column: 73
        }
      },
      "49": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 39
        }
      },
      "50": {
        start: {
          line: 85,
          column: 6
        },
        end: {
          line: 87,
          column: 7
        }
      },
      "51": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 86,
          column: 67
        }
      },
      "52": {
        start: {
          line: 89,
          column: 4
        },
        end: {
          line: 89,
          column: 15
        }
      },
      "53": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 91,
          column: 14
        }
      },
      "54": {
        start: {
          line: 94,
          column: 33
        },
        end: {
          line: 115,
          column: 1
        }
      },
      "55": {
        start: {
          line: 95,
          column: 22
        },
        end: {
          line: 95,
          column: 57
        }
      },
      "56": {
        start: {
          line: 96,
          column: 12
        },
        end: {
          line: 96,
          column: 27
        }
      },
      "57": {
        start: {
          line: 98,
          column: 2
        },
        end: {
          line: 111,
          column: 5
        }
      },
      "58": {
        start: {
          line: 99,
          column: 24
        },
        end: {
          line: 99,
          column: 64
        }
      },
      "59": {
        start: {
          line: 100,
          column: 22
        },
        end: {
          line: 100,
          column: 50
        }
      },
      "60": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 106,
          column: 5
        }
      },
      "61": {
        start: {
          line: 103,
          column: 24
        },
        end: {
          line: 103,
          column: 48
        }
      },
      "62": {
        start: {
          line: 104,
          column: 20
        },
        end: {
          line: 104,
          column: 88
        }
      },
      "63": {
        start: {
          line: 105,
          column: 6
        },
        end: {
          line: 105,
          column: 33
        }
      },
      "64": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "65": {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 61
        }
      },
      "66": {
        start: {
          line: 113,
          column: 15
        },
        end: {
          line: 113,
          column: 20
        }
      },
      "67": {
        start: {
          line: 114,
          column: 2
        },
        end: {
          line: 114,
          column: 14
        }
      },
      "68": {
        start: {
          line: 117,
          column: 40
        },
        end: {
          line: 117,
          column: 96
        }
      },
      "69": {
        start: {
          line: 117,
          column: 55
        },
        end: {
          line: 117,
          column: 96
        }
      },
      "70": {
        start: {
          line: 119,
          column: 40
        },
        end: {
          line: 122,
          column: 1
        }
      },
      "71": {
        start: {
          line: 120,
          column: 27
        },
        end: {
          line: 120,
          column: 49
        }
      },
      "72": {
        start: {
          line: 121,
          column: 2
        },
        end: {
          line: 121,
          column: 28
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 3,
            column: 37
          },
          end: {
            line: 3,
            column: 38
          }
        },
        loc: {
          start: {
            line: 3,
            column: 52
          },
          end: {
            line: 17,
            column: 1
          }
        },
        line: 3
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 6,
            column: 16
          },
          end: {
            line: 6,
            column: 17
          }
        },
        loc: {
          start: {
            line: 6,
            column: 26
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 6
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 7,
            column: 39
          },
          end: {
            line: 7,
            column: 40
          }
        },
        loc: {
          start: {
            line: 7,
            column: 55
          },
          end: {
            line: 14,
            column: 5
          }
        },
        line: 7
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 10,
            column: 35
          },
          end: {
            line: 10,
            column: 36
          }
        },
        loc: {
          start: {
            line: 10,
            column: 49
          },
          end: {
            line: 13,
            column: 7
          }
        },
        line: 10
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 19,
            column: 34
          },
          end: {
            line: 19,
            column: 35
          }
        },
        loc: {
          start: {
            line: 19,
            column: 59
          },
          end: {
            line: 23,
            column: 1
          }
        },
        line: 19
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 25,
            column: 43
          },
          end: {
            line: 25,
            column: 44
          }
        },
        loc: {
          start: {
            line: 25,
            column: 72
          },
          end: {
            line: 38,
            column: 1
          }
        },
        line: 25
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 28,
            column: 20
          },
          end: {
            line: 28,
            column: 21
          }
        },
        loc: {
          start: {
            line: 28,
            column: 33
          },
          end: {
            line: 36,
            column: 3
          }
        },
        line: 28
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 40,
            column: 45
          },
          end: {
            line: 40,
            column: 46
          }
        },
        loc: {
          start: {
            line: 40,
            column: 73
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 40
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 41,
            column: 31
          },
          end: {
            line: 41,
            column: 32
          }
        },
        loc: {
          start: {
            line: 41,
            column: 48
          },
          end: {
            line: 65,
            column: 3
          }
        },
        line: 41
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 69,
            column: 29
          },
          end: {
            line: 69,
            column: 30
          }
        },
        loc: {
          start: {
            line: 69,
            column: 44
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 69
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 71,
            column: 32
          },
          end: {
            line: 71,
            column: 33
          }
        },
        loc: {
          start: {
            line: 71,
            column: 47
          },
          end: {
            line: 90,
            column: 3
          }
        },
        line: 71
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 74,
            column: 18
          },
          end: {
            line: 74,
            column: 19
          }
        },
        loc: {
          start: {
            line: 74,
            column: 32
          },
          end: {
            line: 88,
            column: 5
          }
        },
        line: 74
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 94,
            column: 33
          },
          end: {
            line: 94,
            column: 34
          }
        },
        loc: {
          start: {
            line: 94,
            column: 59
          },
          end: {
            line: 115,
            column: 1
          }
        },
        line: 94
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 98,
            column: 16
          },
          end: {
            line: 98,
            column: 17
          }
        },
        loc: {
          start: {
            line: 98,
            column: 30
          },
          end: {
            line: 111,
            column: 3
          }
        },
        line: 98
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 117,
            column: 40
          },
          end: {
            line: 117,
            column: 41
          }
        },
        loc: {
          start: {
            line: 117,
            column: 55
          },
          end: {
            line: 117,
            column: 96
          }
        },
        line: 117
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 119,
            column: 40
          },
          end: {
            line: 119,
            column: 41
          }
        },
        loc: {
          start: {
            line: 119,
            column: 57
          },
          end: {
            line: 122,
            column: 1
          }
        },
        line: 119
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 18
          },
          end: {
            line: 21,
            column: 55
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 18
          },
          end: {
            line: 21,
            column: 35
          }
        }, {
          start: {
            line: 21,
            column: 39
          },
          end: {
            line: 21,
            column: 55
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }, {
          start: {
            line: 29,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        }],
        line: 29
      },
      "2": {
        loc: {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        }, {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 34,
            column: 7
          }
        }],
        line: 32
      },
      "3": {
        loc: {
          start: {
            line: 44,
            column: 20
          },
          end: {
            line: 44,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 44,
            column: 20
          },
          end: {
            line: 44,
            column: 31
          }
        }, {
          start: {
            line: 44,
            column: 35
          },
          end: {
            line: 44,
            column: 63
          }
        }],
        line: 44
      },
      "4": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }, {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 51,
            column: 5
          }
        }],
        line: 47
      },
      "5": {
        loc: {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }, {
          start: {
            line: 53,
            column: 4
          },
          end: {
            line: 57,
            column: 5
          }
        }],
        line: 53
      },
      "6": {
        loc: {
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 53,
            column: 8
          },
          end: {
            line: 53,
            column: 19
          }
        }, {
          start: {
            line: 53,
            column: 23
          },
          end: {
            line: 53,
            column: 32
          }
        }, {
          start: {
            line: 53,
            column: 36
          },
          end: {
            line: 53,
            column: 58
          }
        }, {
          start: {
            line: 53,
            column: 62
          },
          end: {
            line: 53,
            column: 91
          }
        }],
        line: 53
      },
      "7": {
        loc: {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }, {
          start: {
            line: 61,
            column: 4
          },
          end: {
            line: 63,
            column: 5
          }
        }],
        line: 61
      },
      "8": {
        loc: {
          start: {
            line: 61,
            column: 11
          },
          end: {
            line: 61,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 11
          },
          end: {
            line: 61,
            column: 33
          }
        }, {
          start: {
            line: 61,
            column: 37
          },
          end: {
            line: 61,
            column: 58
          }
        }],
        line: 61
      },
      "9": {
        loc: {
          start: {
            line: 62,
            column: 19
          },
          end: {
            line: 62,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 62,
            column: 27
          },
          end: {
            line: 62,
            column: 54
          }
        }, {
          start: {
            line: 62,
            column: 57
          },
          end: {
            line: 62,
            column: 94
          }
        }],
        line: 62
      },
      "10": {
        loc: {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 83,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 83,
            column: 7
          }
        }, {
          start: {
            line: 79,
            column: 6
          },
          end: {
            line: 83,
            column: 7
          }
        }],
        line: 79
      },
      "11": {
        loc: {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        }, {
          start: {
            line: 85,
            column: 6
          },
          end: {
            line: 87,
            column: 7
          }
        }],
        line: 85
      },
      "12": {
        loc: {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }, {
          start: {
            line: 102,
            column: 4
          },
          end: {
            line: 106,
            column: 5
          }
        }],
        line: 102
      },
      "13": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }, {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }],
        line: 108
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184",
    hash: "358c63004dd457f3bae829bd8c83abb120609bde"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  return coverage[path] = coverageData;
}();

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.referenceFromReferenceId = exports.referenceIdFromReference = exports.dataFromReference = exports.dataFromBooks = exports.versesFromReferenceIdAndBooks = exports.rangeFromVerseAndVerseKeys = exports.isVerseKeyInRange = exports.referenceIdsFromBooks = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _verseObjects = require("../../core/selections/verseObjects");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

cov_2cdkxug3hl.s[0]++;

var referenceIdsFromBooks = function referenceIdsFromBooks(_ref) {
  var books = _ref.books;
  cov_2cdkxug3hl.f[0]++;
  var referenceIds = (cov_2cdkxug3hl.s[1]++, new Set([]));
  cov_2cdkxug3hl.s[2]++;
  books.forEach(function (book) {
    cov_2cdkxug3hl.f[1]++;
    cov_2cdkxug3hl.s[3]++;
    Object.keys(book.chapters).forEach(function (chapterKey) {
      cov_2cdkxug3hl.f[2]++;
      var chapter = (cov_2cdkxug3hl.s[4]++, book.chapters[chapterKey]);
      cov_2cdkxug3hl.s[5]++;
      Object.keys(chapter).forEach(function (verseKey) {
        cov_2cdkxug3hl.f[3]++;
        var referenceId = (cov_2cdkxug3hl.s[6]++, chapterKey + ':' + verseKey);
        cov_2cdkxug3hl.s[7]++;
        referenceIds.add(referenceId);
      });
    });
  });
  cov_2cdkxug3hl.s[8]++;
  return (0, _toConsumableArray2.default)(referenceIds);
};

exports.referenceIdsFromBooks = referenceIdsFromBooks;
cov_2cdkxug3hl.s[9]++;

var isVerseKeyInRange = function isVerseKeyInRange(_ref2) {
  var range = _ref2.range,
      verseKey = _ref2.verseKey;
  cov_2cdkxug3hl.f[4]++;

  var _ref3 = (cov_2cdkxug3hl.s[10]++, range.split('-')),
      _ref4 = (0, _slicedToArray2.default)(_ref3, 2),
      first = _ref4[0],
      last = _ref4[1];

  var inRange = (cov_2cdkxug3hl.s[11]++, (cov_2cdkxug3hl.b[0][0]++, first <= verseKey) && (cov_2cdkxug3hl.b[0][1]++, verseKey <= last));
  cov_2cdkxug3hl.s[12]++;
  return inRange;
};

exports.isVerseKeyInRange = isVerseKeyInRange;
cov_2cdkxug3hl.s[13]++;

var rangeFromVerseAndVerseKeys = function rangeFromVerseAndVerseKeys(_ref5) {
  var verseKeys = _ref5.verseKeys,
      verseKey = _ref5.verseKey;
  cov_2cdkxug3hl.f[5]++;
  var range;
  cov_2cdkxug3hl.s[14]++;
  verseKeys.forEach(function (_verseKey) {
    cov_2cdkxug3hl.f[6]++;
    cov_2cdkxug3hl.s[15]++;

    if (_verseKey.includes('-')) {
      cov_2cdkxug3hl.b[1][0]++; // if the verseKey includes - it is a range

      var inRange = (cov_2cdkxug3hl.s[16]++, isVerseKeyInRange({
        range: _verseKey,
        verseKey: verseKey
      }));
      cov_2cdkxug3hl.s[17]++;

      if (inRange) {
        cov_2cdkxug3hl.b[2][0]++;
        cov_2cdkxug3hl.s[18]++;
        range = _verseKey;
      } else {
        cov_2cdkxug3hl.b[2][1]++;
      }
    } else {
      cov_2cdkxug3hl.b[1][1]++;
    }

    ;
  });
  cov_2cdkxug3hl.s[19]++;
  return range;
};

exports.rangeFromVerseAndVerseKeys = rangeFromVerseAndVerseKeys;
cov_2cdkxug3hl.s[20]++;

var versesFromReferenceIdAndBooks = function versesFromReferenceIdAndBooks(_ref6) {
  var referenceId = _ref6.referenceId,
      books = _ref6.books;
  cov_2cdkxug3hl.f[7]++;
  var versesData = (cov_2cdkxug3hl.s[21]++, books.map(function (book, index) {
    cov_2cdkxug3hl.f[8]++;
    var reference = (cov_2cdkxug3hl.s[22]++, referenceFromReferenceId(referenceId));
    var chapterData = (cov_2cdkxug3hl.s[23]++, book.chapters[reference.chapter]);
    var verseData = (cov_2cdkxug3hl.s[24]++, (cov_2cdkxug3hl.b[3][0]++, chapterData) && (cov_2cdkxug3hl.b[3][1]++, chapterData[reference.verse]));
    var range;
    cov_2cdkxug3hl.s[25]++;

    if (!verseData) {
      cov_2cdkxug3hl.b[4][0]++;
      var verseKeys = (cov_2cdkxug3hl.s[26]++, Object.keys(chapterData));
      cov_2cdkxug3hl.s[27]++;
      range = rangeFromVerseAndVerseKeys({
        verseKeys: verseKeys,
        verseKey: reference.verse
      });
      cov_2cdkxug3hl.s[28]++;
      verseData = chapterData[range];
    } else {
      cov_2cdkxug3hl.b[4][1]++;
    }

    cov_2cdkxug3hl.s[29]++;

    if ((cov_2cdkxug3hl.b[6][0]++, index === 0) && (cov_2cdkxug3hl.b[6][1]++, verseData) && (cov_2cdkxug3hl.b[6][2]++, verseData.verseObjects) && (cov_2cdkxug3hl.b[6][3]++, verseData.verseObjects.length)) {
      cov_2cdkxug3hl.b[5][0]++;

      var _verseData = (cov_2cdkxug3hl.s[30]++, _objectSpread({}, verseData));

      cov_2cdkxug3hl.s[31]++;
      _verseData.verseObjects = (0, _verseObjects.occurrenceInjectVerseObjects)(_verseData.verseObjects);
      cov_2cdkxug3hl.s[32]++;
      verseData = _verseData;
    } else {
      cov_2cdkxug3hl.b[5][1]++;
    }

    var verseTitle = (cov_2cdkxug3hl.s[33]++, reference.verse);
    cov_2cdkxug3hl.s[34]++;

    if (!((cov_2cdkxug3hl.b[8][0]++, verseTitle === 'front') || (cov_2cdkxug3hl.b[8][1]++, verseTitle === 'back'))) {
      cov_2cdkxug3hl.b[7][0]++;
      cov_2cdkxug3hl.s[35]++;
      verseTitle = range ? (cov_2cdkxug3hl.b[9][0]++, reference.chapter + ':' + range) : (cov_2cdkxug3hl.b[9][1]++, reference.chapter + ':' + reference.verse);
    } else {
      cov_2cdkxug3hl.b[7][1]++;
    }

    cov_2cdkxug3hl.s[36]++;
    return {
      verseData: verseData,
      verseTitle: verseTitle
    };
  }));
  cov_2cdkxug3hl.s[37]++;
  return versesData;
};

exports.versesFromReferenceIdAndBooks = versesFromReferenceIdAndBooks;
cov_2cdkxug3hl.s[38]++;

var dataFromBooks = function dataFromBooks(_ref7) {
  var books = _ref7.books;
  cov_2cdkxug3hl.f[9]++;
  var referenceIds = (cov_2cdkxug3hl.s[39]++, referenceIdsFromBooks({
    books: books
  }));
  var data = (cov_2cdkxug3hl.s[40]++, referenceIds.map(function (referenceId) {
    cov_2cdkxug3hl.f[10]++;
    var row = (cov_2cdkxug3hl.s[41]++, {
      referenceId: referenceId
    });
    cov_2cdkxug3hl.s[42]++;
    books.forEach(function (_, index) {
      cov_2cdkxug3hl.f[11]++;

      var _ref8 = (cov_2cdkxug3hl.s[43]++, referenceId.split(':')),
          _ref9 = (0, _slicedToArray2.default)(_ref8, 2),
          chapterKey = _ref9[0],
          verseKey = _ref9[1];

      var chapterData = (cov_2cdkxug3hl.s[44]++, books[index].chapters[chapterKey]);
      var verseData = (cov_2cdkxug3hl.s[45]++, chapterData[verseKey]);
      cov_2cdkxug3hl.s[46]++;

      if (!verseData) {
        cov_2cdkxug3hl.b[10][0]++;
        var verseKeys = (cov_2cdkxug3hl.s[47]++, Object.keys(chapterData));
        var range = (cov_2cdkxug3hl.s[48]++, rangeFromVerseAndVerseKeys({
          verseKeys: verseKeys,
          verseKey: verseKey
        }));
        cov_2cdkxug3hl.s[49]++;
        verseData = chapterData[range];
      } else {
        cov_2cdkxug3hl.b[10][1]++;
      }

      cov_2cdkxug3hl.s[50]++;

      if (verseData) {
        cov_2cdkxug3hl.b[11][0]++;
        cov_2cdkxug3hl.s[51]++;
        row[index] = JSON.stringify(_objectSpread({
          referenceId: referenceId
        }, verseData));
      } else {
        cov_2cdkxug3hl.b[11][1]++;
      }
    });
    cov_2cdkxug3hl.s[52]++;
    return row;
  }));
  cov_2cdkxug3hl.s[53]++;
  return data;
};

exports.dataFromBooks = dataFromBooks;
cov_2cdkxug3hl.s[54]++;

var dataFromReference = function dataFromReference(_ref10) {
  var books = _ref10.books,
      reference = _ref10.reference;
  cov_2cdkxug3hl.f[12]++;
  var referenceId = (cov_2cdkxug3hl.s[55]++, referenceIdFromReference(reference));
  var row = (cov_2cdkxug3hl.s[56]++, {
    referenceId: referenceId
  });
  cov_2cdkxug3hl.s[57]++;
  books.forEach(function (_, index) {
    cov_2cdkxug3hl.f[13]++;
    var chapterData = (cov_2cdkxug3hl.s[58]++, books[index].chapters[reference.chapter]);
    var verseData = (cov_2cdkxug3hl.s[59]++, chapterData[reference.verse]);
    cov_2cdkxug3hl.s[60]++;

    if (!verseData) {
      cov_2cdkxug3hl.b[12][0]++;
      var verseKeys = (cov_2cdkxug3hl.s[61]++, Object.keys(chapterData));
      var range = (cov_2cdkxug3hl.s[62]++, rangeFromVerseAndVerseKeys({
        verseKeys: verseKeys,
        verseKey: reference.verse
      }));
      cov_2cdkxug3hl.s[63]++;
      verse = chapterData[range];
    } else {
      cov_2cdkxug3hl.b[12][1]++;
    }

    cov_2cdkxug3hl.s[64]++;

    if (verse) {
      cov_2cdkxug3hl.b[13][0]++;
      cov_2cdkxug3hl.s[65]++;
      row[index] = JSON.stringify(_objectSpread({
        referenceId: referenceId
      }, verse));
    } else {
      cov_2cdkxug3hl.b[13][1]++;
    }
  });
  var data = (cov_2cdkxug3hl.s[66]++, [row]);
  cov_2cdkxug3hl.s[67]++;
  return data;
};

exports.dataFromReference = dataFromReference;
cov_2cdkxug3hl.s[68]++;

var referenceIdFromReference = function referenceIdFromReference(reference) {
  cov_2cdkxug3hl.f[14]++;
  cov_2cdkxug3hl.s[69]++;
  return reference.chapter + ':' + reference.verse;
};

exports.referenceIdFromReference = referenceIdFromReference;
cov_2cdkxug3hl.s[70]++;

var referenceFromReferenceId = function referenceFromReferenceId(referenceId) {
  cov_2cdkxug3hl.f[15]++;

  var _ref11 = (cov_2cdkxug3hl.s[71]++, referenceId.split(':')),
      _ref12 = (0, _slicedToArray2.default)(_ref11, 2),
      chapter = _ref12[0],
      verse = _ref12[1];

  cov_2cdkxug3hl.s[72]++;
  return {
    chapter: chapter,
    verse: verse
  };
};

exports.referenceFromReferenceId = referenceFromReferenceId;